import * as React from 'react';
import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { ColorPicker, backColors } from 'owa-color-picker';
import { setBackgroundColor } from 'roosterjs-editor-api';

const backColor: RibbonButton = {
    key: 'backColor',
    title: () => strings.backColor,
    imageSrc: require('../svg/backcolor.svg'),
    createDropDownCallback: (target, plugin, dismiss, logUsage) => (
        <ColorPicker
            menuTargetElement={target}
            onDismissMenu={dismiss}
            colors={backColors.get()}
            onSelectColor={color => {
                setBackgroundColor(plugin.getEditor(), color.code);
                logUsage('setBackgroundColor', color.code);
            }}
            shouldFocusOnMount={true}
            selectedColor={plugin.getFormatState().backgroundColor}
        />
    ),
};

export default backColor;
